<template>
<div>
	<spinner v-if="inlineSpinner" :inline="true"></spinner>
	<div v-else>
		<form-group v-if="!editMode && selectedCategory" label="Selected Category"
			col-class="col-md-4">

			<div class="d-flex">
				<field v-if="selectedCategory && !editMode"
					class="flex-grow-1"
					:params="{type:'text'}"
					:readonly="true"
					:value="selectedCategory.name">
				</field>
				<button class="btn btn-light btn-attached" type="button" v-on:click="editSelectedCategory">
					<i class="fa fa-pencil-alt"></i>
				</button>
			</div>

		</form-group>
		<div v-else>
			<div v-if="breadcrumb.length > 0">
				<nav class="mb-2">
					<div class="d-flex align-items-center justify-content-between">
						<ol class="breadcrumb flex-grow-1 mb-0">
							<li class="breadcrumb-item"><a href="#"><i class="fa fa-arrow-up" v-on:click="upCat"></i></a></li>
							<li class="breadcrumb-item" :class="{active: index == breadcrumb.length - 1}" v-for="(cat,index) in breadcrumb">
								<a v-if="index != breadcrumb.length - 1" href="#" v-on:click="toCat(cat)">{{ cat.name }}</a>
								<span v-else>{{cat.name}}</span>
							</li>
							
						</ol>
						<button v-if="currentCategory" type="button" class="btn btn-primary btn-attached" v-on:click="selectCategory" :disabled="useButtonDisabled">USE</button>
					</div>
				</nav>
				
			</div>
			<div class="list-group">
				<div>
					<button v-for="cat in categories" type="button" class="list-group-item list-group-item-action" v-on:click="openCat(cat)">
						{{ cat.name }} 
					</button>
				</div>
			</div>
		</div>
		
	</div>
</div>
</template>
<script type="text/javascript">
import Spinner from "@/components/Spinner"
import Field from "@/components/Field"
import FormGroup from "@/components/FormGroup"

export default {
	name: "TreeCategorySelector",
	components: {
		Spinner,
		Field,
		FormGroup
	},
	props: [
		"categoryApiResource",
		"parentKey",
		"requireBottomCategory"
	],
	data() {
		return {
			categories: [],
			selectedCategory: null,
			currentCategory: null,
			inlineSpinner: false,
			editMode: false,
			breadcrumb: [] 
		}
	},
	watch: {

	},
	computed: {
		useButtonDisabled() {
			if (this.categories.length > 0)
				return true
			return false
		}
	},
	methods: {
		openCat(cat) {
			if (!this.currentCategory || cat.id != this.currentCategory.id) {
				this.currentCategory = cat
				this.breadcrumb.push(cat)

				this.fetchCategories()
			}
		},
		upCat() {
			this.currentCategory = this.breadcrumb[this.breadcrumb.length - 2] //second to last
			this.fetchCategories()
			this.breadcrumb.pop()

		},
		//jump to a category above
		toCat(cat) {
			this.currentCategory = cat

			//figure out where to splice off the end of the breadcrumb array
			let indexToSplice = this.breadcrumb.map(item => {return item.id}).indexOf(cat.id)+1

			this.breadcrumb.splice(indexToSplice)

			this.fetchCategories()
		},
		editSelectedCategory() {
			this.editMode = true
			this.currentCategory = this.selectedCategory
			this.fetchCategories()
		},
		selectCategory() {
			this.selectedCategory = this.currentCategory
			this.editMode = false
			this.$emit('categorySelected',this.selectedCategory)
		},
		fetchCategories() {
			let vm = this

			this.inlineSpinner = true

			let params = {
				include: [
					this.categoryApiResource
				]
			}

			if (this.currentCategory) {
				params.filters = [
					[this.parentKey,this.currentCategory.id]
				]
			}
			else {
				//get top level categories
				params.filters = [
					[this.parentKey,0]
				]
			}

			this.getJSON(this.categoryApiResource+"/get",params).then(response => {
				vm.inlineSpinner = false
				if (response.success)
					vm.categories = response.data
			})
		}
	},
	created() {
		this.fetchCategories()
	}
}
</script>